<template>

  <v-dialog
      v-model="show"
      persistent
      shrink
      :width="150"
  >
    <v-card class="pa-2">
      <v-progress-linear
          indeterminate
          :width="5"
          color="primary"
      ></v-progress-linear>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data: ()=> ({

    }),
    props: {
      value: Boolean
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
